<template>
    <v-content
        class="ma-0 pa-0"
    >
        <v-card
            outlined
            class="ma-0 pb-5"
        >

            <!---------------------------->
            <!--       Page Title       -->
            <!---------------------------->
            <v-card-title
                class="headline"
            >
                Forgot Password
            </v-card-title>
            <v-row
                no-gutters
            >
            
            <!--         Email          -->
                <v-text-field
                    v-model="email"
                    label="Email"
                    outlined
                    hide-details
                    class="px-5 mt-5 mb-0 py-0"
                    @keydown.enter="updatePassword"
                />
            </v-row>
            
            <!--        Password        -->
            <v-card
                outlined
                class="mx-5 mt-5 pb-5"
            >
                <v-row
                    no-gutters
                >
                    <v-text-field
                        v-model="password1"
                        label="New Password"
                        outlined
                        hide-details
                        type="password"
                        class="px-5 mt-5 mb-0 py-0"
                        @keydown.enter="updatePassword"
                    />
                </v-row>
                <v-row
                    no-gutters
                >
                    <v-text-field
                        v-model="password2"
                        label="Confirm Password"
                        outlined
                        hide-details
                        type="password"
                        class="px-5 mt-5 mb-0 py-0"
                        @keydown.enter="updatePassword"
                    />
                </v-row>
            </v-card>

            <!--    Confirmation Code   -->
            <v-row
                no-gutters
            >
                <v-text-field
                    v-model="code"
                    label="Confirmation Code"
                    outlined
                    hide-details
                    class="px-5 mt-3 mb-0 py-0"
                    @keydown.enter="updatePassword"
                />
            </v-row>
            <v-row
                no-gutters
            >
                <v-col
                    class="text-left my-0 ml-5 pa-0 grey--text text--darken-2 caption"
                >
                    <a @click.prevent="sendCode">Send recovery code</a>
                </v-col>
            </v-row>
            <v-row
                no-gutters
            >
                <v-col
                    class="text-left my-0 mx-5 pa-0 red--text caption"
                >
                    {{forgotPasswordError}}
                </v-col>
            </v-row>
            <v-row
                no-gutters
            >
                <v-col
                    class="text-left my-0 mx-5 pa-0 grey--text text--darken-4 caption"
                >
                    {{forgotPasswordSuccess}}
                </v-col>
            </v-row>
            <v-row
                no-gutters
                align="center"
                class="mt-5"
            >
                <v-col
                    class="ml-5 body-2"
                >
                    <a
                        @click.prevent="signIn"
                    >
                        Sign In
                    </a>
                </v-col>
                <v-col
                    class="text-right mr-5 mb-0 pa-0"
                >
                    <v-btn
                        color="info"
                        @click.prevent="updatePassword"
                        :disabled="disableUpdate"
                    >
                        Update
                    </v-btn>
                </v-col>
            </v-row>
            <v-row
                no-gutters
            >
                <v-col
                    class="text-right mt-1 pt-0 mx-5 red--text caption"
                >
                    <v-row no-gutters>
                        <v-col
                            class="text-right ma-0 pa-0"
                        >
                            {{incorrectCodeMessage}}
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col
                            class="text-right ma-0 pa-0"
                        >
                            {{errorMessage1}}
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col
                            class="text-right ma-0 pa-0"
                        >
                            {{errorMessage2}}
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col
                            class="text-right ma-0 pa-0"
                        >
                            {{errorMessage3}}
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-card>
    </v-content>
</template>

<script>
    import { Auth } from 'aws-amplify'

    export default {
        data: () => ({
            email: null,
            password1: null,
            password2: null,
            code: null,
            forgotPasswordError: null,
            forgotPasswordSuccess: null,
            incorrectCodeMessage: null,
            errorMessage1: null,
            errorMessage2: null,
            errorMessage3: null,
        }),

        methods: {
            signIn: function() {
                this.$store.dispatch('login/currentAuthView','SignIn'); 
            },

            sendCode: function() {
                this.forgotPasswordError = null;
                this.forgotPasswordSuccess = null;
                
                if(this.email == null | this.email == '') {
                    this.forgotPasswordError = 'Please enter email first'
                } else {
                    Auth.forgotPassword(this.email)
                    .then(
                        data => {
                            console.log(data);
                            this.forgotPasswordSuccess = 'Code sent to ';
                            this.forgotPasswordSuccess += data.CodeDeliveryDetails.Destination;
                        }
                    ).catch(
                        error => {
                            if (error.message == 'Username/client id combination not found.'){
                                this.forgotPasswordError = 'User not found'
                            }
                            console.log(error)
                        }
                    )
                }
            },

            updatePassword: function() {
                this.incorrectCodeMessage = null;
                this.errorMessage1 = null;
                this.errorMessage2 = null;
                this.errorMessage3 = null;

                if (this.password1 != this.password2) {
                    this.errorMessage1 = "Passwords do not match"
                }
                
                if (this.password1.length < 6 | this.password2.length < 6) {
                    this.errorMessage2 = "Password must be at least 6 characters"
                }

                if (this.errorMessage1 == null && this.errorMessage2 == null) {
                    Auth.forgotPasswordSubmit(this.email, this.code, this.password1)
                    .then(
                        data => {
                            console.log(data);
                            this.errorMessage1 = null;
                            this.errorMessage2 = null;
                            
                            Auth.signIn({
                                username: this.email,
                                password: this.password1
                            }).then(
                                user => {
                                    console.log(user);
                                    this.email = null;
                                    this.password1 = null;
                                    this.password2 = null;
                                    this.code = null;
                                    this.$store.dispatch('login/authDialog',false);
                                    this.$store.dispatch('login/signIn');
                                    this.$router.push('/menu');
                                }
                            ).catch(
                                error => {
                                    console.log(error);
                                    if(error.message == "User is not confirmed.") {
                                        this.errorMessage3 = "Email not verified, please verify below";
                                        this.$store.dispatch('login/showConfirmUser',true);
                                    } else {
                                        this.errorMessage3 = "Email or Password is incorrect";
                                    }
                                }
                            )
                    }).catch(
                        error => {
                            console.log(error);
                            this.incorrectCodeMessage = "Code incorrect";
                        }
                    );
                }
            },

        },

        computed: {
            disableUpdate() {
                if(this.email == null | this.email == '' | this.password1 == null | this.password1 == '' | this.password2 == null | this.password2 == '' | this.code == null | this.code == '') {
                    return true
                } else {
                    return false
                }
            },
        }

    }
</script>

<style scoped>
  a {
    color: blue !important;
    text-decoration: underline;
  }
</style>